import { render, staticRenderFns } from "./rejectedIncident.vue?vue&type=template&id=ad2180fa&scoped=true"
import script from "./rejectedIncident.vue?vue&type=script&lang=js"
export * from "./rejectedIncident.vue?vue&type=script&lang=js"
import style0 from "./rejectedIncident.vue?vue&type=style&index=0&id=ad2180fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2180fa",
  null
  
)

export default component.exports